var _templateObject = _taggedTemplateLiteralLoose(['\n  ', '\n'], ['\n  ', '\n']),
  _templateObject2 = _taggedTemplateLiteralLoose(['\n  width: 536px;\n  margin: 32px;\n'], ['\n  width: 536px;\n  margin: 32px;\n']),
  _templateObject3 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  margin-bottom: 8px;\n']),
  _templateObject4 = _taggedTemplateLiteralLoose(['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n'], ['\n  font-weight: 600;\n  font-size: 20px;\n  line-height: 1.4;\n  color: #4a4a4a;\n']),
  _templateObject5 = _taggedTemplateLiteralLoose(['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n'], ['\n  font-size: 16px;\n  line-height: 1.5;\n  font-weight: normal;\n  color: #4a4a4a;\n']),
  _templateObject6 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n'], ['\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: flex-end;\n']),
  _templateObject7 = _taggedTemplateLiteralLoose(['\n  text-align: center;\n'], ['\n  text-align: center;\n']),
  _templateObject8 = _taggedTemplateLiteralLoose(['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  margin-bottom: 8px;\n  display: block;\n  color: #f78323;\n'], ['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  margin-bottom: 8px;\n  display: block;\n  color: #f78323;\n']),
  _templateObject9 = _taggedTemplateLiteralLoose(['\n  width: 122px;\n  height: 160px;\n  border-radius: 5px;\n  border: solid 1px #e1e1e1;\n  background-color: #fff;\n  padding: 8px 16px;\n  text-align: center;\n  box-sizing: border-box;\n\n  ', '\n'], ['\n  width: 122px;\n  height: 160px;\n  border-radius: 5px;\n  border: solid 1px #e1e1e1;\n  background-color: #fff;\n  padding: 8px 16px;\n  text-align: center;\n  box-sizing: border-box;\n\n  ', '\n']),
  _templateObject10 = _taggedTemplateLiteralLoose(['\n  font-size: 14px;\n  line-height: 0.86;\n  font-weight: 700;\n  color: #4a4a4a;\n  display: block;\n  margin-bottom: 10px;\n'], ['\n  font-size: 14px;\n  line-height: 0.86;\n  font-weight: 700;\n  color: #4a4a4a;\n  display: block;\n  margin-bottom: 10px;\n']),
  _templateObject11 = _taggedTemplateLiteralLoose(['\n  display: inline-flex;\n  margin-bottom: 6px;\n'], ['\n  display: inline-flex;\n  margin-bottom: 6px;\n']),
  _templateObject12 = _taggedTemplateLiteralLoose(['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  color: #4a4a4a;\n  display: block;\n  margin-bottom: 20px;\n'], ['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  color: #4a4a4a;\n  display: block;\n  margin-bottom: 20px;\n']),
  _templateObject13 = _taggedTemplateLiteralLoose(['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  color: #4a4a4a;\n  display: block;\n  font-weight: 700;\n'], ['\n  font-size: 12px;\n  line-height: 1.25;\n  font-weight: normal;\n  color: #4a4a4a;\n  display: block;\n  font-weight: 700;\n']),
  _templateObject14 = _taggedTemplateLiteralLoose(['\n  min-width: 88px;\n  font-size: 12px;\n'], ['\n  min-width: 88px;\n  font-size: 12px;\n']),
  _templateObject15 = _taggedTemplateLiteralLoose(['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n'], ['\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  align-items: center;\n']),
  _templateObject16 = _taggedTemplateLiteralLoose(['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n'], ['\n  text-decoration: none;\n  line-height: 1.5;\n  font-size: 16px;\n\n  &:hover {\n    text-decoration: underline;\n  }\n']);
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

/* eslint-disable no-console */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-undef */
import React from 'react';
import styled from 'styled-components';
import { Title, Text, Button, Icon, Link } from '@olxbr/design-system/web';
import PropTypes from 'prop-types';
import Config from '../config';
import { Step } from '../constants';
import { sendEvent } from '../util/tracking';
import DeletionService from '../services/AdDeletionService';
var DivCustom = styled.div(_templateObject, function (_ref) {
  var mb = _ref.mb,
    color = _ref.color;
  var style = '';
  if (mb) {
    style += 'margin-bottom: ' + mb + 'px;';
  }
  if (color) {
    style += 'color: ' + color + ';';
  }
  return style;
});
var ContainerDiv = styled.div(_templateObject2);
var CloseModal = styled.div(_templateObject3);
var TitleCustom = styled(Title)(_templateObject4);
var TextDiv = styled(Text)(_templateObject5);
var PackageWrapper = styled.div(_templateObject6);
var PackageHighlight = styled.div(_templateObject7);
var PackageTextHighlight = styled(Text)(_templateObject8);
var Package = styled.div(_templateObject9, function (_ref2) {
  var highlight = _ref2.highlight;
  var style = '';
  if (highlight) {
    style += 'border: solid 1px #f78323;';
  }
  return style;
});
var PackageTitle = styled(Text)(_templateObject10);
var PackageIcon = styled.svg(_templateObject11);
var PackageText = styled(Text)(_templateObject12);
var PackageTextBold = styled(Text)(_templateObject13);
var PackageButton = styled(Button)(_templateObject14);
var ButtonDiv = styled.div(_templateObject15);
var LinkCustom = styled(Link)(_templateObject16);
var Bump = function (_React$Component) {
  _inherits(Bump, _React$Component);
  function Bump() {
    var _temp, _this, _ret;
    _classCallCheck(this, Bump);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.featured = function (packageType) {
      var listId = _this.props.values.listId;
      _this.props.handleChange({
        target: {
          name: 'packageType',
          value: packageType
        }
      });
      sendEvent({
        event_type: 'click',
        object_detail: packageType.toLowerCase(),
        object_name: 'ad_deleting_bump'
      });
      var bumpURL = Config.MYADS_POS_URL + '/v1/pos?packageType=' + packageType + '&listId=' + listId;
      window.location.href = bumpURL;
    }, _this.deleteAndContinue = function () {
      var _this$props$values = _this.props.values,
        listId = _this$props$values.listId,
        reason = _this$props$values.reason;
      DeletionService.deleteAd(listId, reason).then(function () {
        _this.props.nextStep(Step.AD_DELETED);
      }).catch(function (errorMessage) {
        console.log(errorMessage);
        _this.props.nextStep(Step.DELETE_ERROR);
      });
      sendEvent({
        event_type: 'click',
        object_detail: 'delete_button',
        object_name: 'ad_deleting_bump',
        data: {
          reason: _this.props.values.reason,
          listId: _this.props.values.listId
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  Bump.prototype.componentDidMount = function componentDidMount() {
    sendEvent({
      event_type: 'page_view',
      object_detail: 'step_bump',
      object_name: 'ad_deleting_bump'
    });
  };
  Bump.prototype.render = function render() {
    var _this2 = this;
    return React.createElement(ContainerDiv, null, React.createElement(CloseModal, null, React.createElement(Link, {
      href: '',
      onClick: function onClick(e) {
        e.preventDefault();
        _this2.props.closeModal('ad_deleting_bump');
      }
    }, React.createElement(Icon, {
      svgPath: 'M13.0606602,12 L18.5303301,17.4696699 C18.8232233,17.7625631 18.8232233,18.2374369 18.5303301,18.5303301 C18.2374369,18.8232233 17.7625631,18.8232233 17.4696699,18.5303301 L12,13.0606602 L6.53033009,18.5303301 C6.23743687,18.8232233 5.76256313,18.8232233 5.46966991,18.5303301 C5.1767767,18.2374369 5.1767767,17.7625631 5.46966991,17.4696699 L10.9393398,12 L5.46966991,6.53033009 C5.1767767,6.23743687 5.1767767,5.76256313 5.46966991,5.46966991 C5.76256313,5.1767767 6.23743687,5.1767767 6.53033009,5.46966991 L12,10.9393398 L17.4696699,5.46966991 C17.7625631,5.1767767 18.2374369,5.1767767 18.5303301,5.46966991 C18.8232233,5.76256313 18.8232233,6.23743687 18.5303301,6.53033009 L13.0606602,12 Z',
      width: 24,
      height: 24
    }))), React.createElement(DivCustom, {
      mb: 8
    }, React.createElement(TitleCustom, null, 'Ainda d\xE1 tempo!')), React.createElement(DivCustom, {
      mb: 16
    }, React.createElement(TextDiv, {
      tag: 'span'
    }, 'Destaque seu an\xFAncio e aumente as chances de vender.')), React.createElement(DivCustom, {
      mb: 32
    }, React.createElement(PackageWrapper, null, React.createElement(Package, null, React.createElement(PackageIcon, {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, React.createElement('g', {
      fill: 'none',
      fillRule: 'nonzero'
    }, React.createElement('circle', {
      cx: '12',
      cy: '12',
      r: '12',
      fill: '#D9F0F8'
    }), React.createElement('path', {
      fill: '#28B5D9',
      fillOpacity: '.7',
      d: 'M16.572 11.541H7.43l4.488 5.308 4.654-5.308zm-9.16-1.059h9.149l-1.709-2.187H9.076l-1.663 2.187zm7.736-3.24l.094.022.137.045.082.073c.04.038.04.038.093.098l2.558 3.268.029.085a.687.687 0 0 1-.015.474l-.045.12-.064.072-5.63 6.42a.607.607 0 0 1-.253.156.718.718 0 0 1-.238.039.717.717 0 0 1-.168-.025l-.135-.053a.716.716 0 0 1-.178-.145l-5.453-6.447-.075-.116a.673.673 0 0 1-.062-.322.705.705 0 0 1 .129-.349l2.4-3.16a.664.664 0 0 1 .372-.245l.125-.015h6.164a.662.662 0 0 1 .133.005z'
    }))), React.createElement(PackageTitle, {
      tag: 'span'
    }, 'Diamante'), React.createElement(PackageText, {
      tag: 'span'
    }, React.createElement(PackageTextBold, {
      tag: 'span',
      fontWeight: '700'
    }, 'at\xE9 20x mais'), ' ', 'visualiza\xE7\xF5es'), React.createElement(PackageButton, {
      size: 'small',
      fluid: true,
      outline: true,
      onClick: function onClick() {
        return _this2.featured('PACKAGE_DIAMOND');
      }
    }, 'Destacar')), React.createElement(PackageHighlight, null, React.createElement(PackageTextHighlight, {
      tag: 'span'
    }, 'Recomendado'), React.createElement(Package, {
      highlight: true
    }, React.createElement(PackageIcon, {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, React.createElement('g', {
      fill: 'none',
      fillRule: 'nonzero'
    }, React.createElement('circle', {
      cx: '12',
      cy: '12',
      r: '12',
      fill: '#FFF3CE'
    }), React.createElement('path', {
      fill: '#E29E1F',
      d: 'M12.076 14.294a7.851 7.851 0 0 1-.081 0 2.987 2.987 0 0 1-.708 1.765h1.496a2.987 2.987 0 0 1-.707-1.765zm1.055-.097a1.941 1.941 0 0 0 1.94 1.862h.811a.53.53 0 0 1 0 1.059H8.118a.53.53 0 0 1 0-1.06H9c1.041 0 1.89-.819 1.939-1.848-2.14-.375-2.962-2.01-2.997-5.172a.932.932 0 1 0-.324 1.806v1.04a1.971 1.971 0 1 1 .341-3.913c.024-.504.07-.952.14-1.357a.53.53 0 0 1 .522-.438h6.758a.53.53 0 0 1 .521.438c.072.405.117.853.14 1.357a1.971 1.971 0 1 1 .34 3.914l.001-1.04a.932.932 0 1 0-.323-1.807c-.035 3.127-.839 4.761-2.927 5.159zM9.079 7.235C9.025 7.692 9 8.215 9 8.824c0 3.277.72 4.411 3 4.411 2.28 0 3-1.134 3-4.411 0-.608-.025-1.132-.079-1.589H9.08z',
      opacity: '.7'
    }))), React.createElement(PackageTitle, {
      tag: 'span'
    }, 'Ouro'), React.createElement(PackageText, {
      tag: 'span'
    }, React.createElement(PackageTextBold, {
      tag: 'span',
      fontWeight: 700
    }, 'at\xE9 16x mais'), ' ', 'visualiza\xE7\xF5es'), React.createElement(PackageButton, {
      size: 'small',
      fluid: true,
      onClick: function onClick() {
        return _this2.featured('PACKAGE_GOLD');
      }
    }, 'Destacar'))), React.createElement(Package, null, React.createElement(PackageIcon, {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, React.createElement('g', {
      fill: 'none',
      fillRule: 'nonzero'
    }, React.createElement('circle', {
      cx: '12',
      cy: '12',
      r: '12',
      fill: '#F1F1F1'
    }), React.createElement('path', {
      fill: '#979797',
      d: 'M13.891 12.054l2.95-4.915a.53.53 0 0 1 .907.545l-3.072 5.12a3.353 3.353 0 1 1-5.353 0l-3.071-5.12a.53.53 0 1 1 .908-.545l2.949 4.915c.237-.162.495-.294.77-.392l.504-.838-2.308-3.846a.53.53 0 1 1 .908-.544L12 9.794l2.017-3.36a.53.53 0 1 1 .908.544l-2.7 4.5c.615.04 1.186.248 1.666.576zM12 17.118a2.294 2.294 0 1 0 0-4.589 2.294 2.294 0 0 0 0 4.589z',
      opacity: '.7'
    }))), React.createElement(PackageTitle, {
      tag: 'span'
    }, 'Prata'), React.createElement(PackageText, {
      tag: 'span'
    }, React.createElement(PackageTextBold, {
      tag: 'span',
      fontWeight: 700
    }, 'at\xE9 8x mais'), ' ', 'visualiza\xE7\xF5es'), React.createElement(PackageButton, {
      size: 'small',
      fluid: true,
      outline: true,
      onClick: function onClick() {
        return _this2.featured('PACKAGE_SILVER');
      }
    }, 'Destacar')), React.createElement(Package, null, React.createElement(PackageIcon, {
      xmlns: 'http://www.w3.org/2000/svg',
      width: '24',
      height: '24',
      viewBox: '0 0 24 24'
    }, React.createElement('g', {
      fill: 'none',
      fillRule: 'nonzero'
    }, React.createElement('circle', {
      cx: '12',
      cy: '12',
      r: '12',
      fill: '#FAECFF'
    }), React.createElement('path', {
      fill: '#6e0ad6',
      d: 'M12.53 13.278l1.92 1.92a.53.53 0 1 0 .748-.749l-2.824-2.823a.53.53 0 0 0-.748 0l-2.824 2.823a.53.53 0 1 0 .749.749l1.92-1.92v4.37a.53.53 0 0 0 1.058 0v-4.37zm-4.06-.749a.53.53 0 1 0 0-1.058H6.354a.176.176 0 0 1-.177-.177V8.471c0-.098.08-.177.177-.177h11.294c.098 0 .177.08.177.177v2.823a.176.176 0 0 1-.177.177H15.53a.53.53 0 1 0 0 1.058h2.118c.682 0 1.235-.553 1.235-1.235V8.471c0-.683-.553-1.236-1.235-1.236H6.353c-.682 0-1.235.553-1.235 1.236v2.823c0 .682.553 1.235 1.235 1.235H8.47z',
      opacity: '.6'
    }))), React.createElement(PackageTitle, {
      tag: 'span'
    }, 'B\xE1sico'), React.createElement(PackageText, {
      tag: 'span'
    }, React.createElement(PackageTextBold, {
      tag: 'span',
      fontWeight: 700
    }, 'at\xE9 2x mais'), ' ', 'visualiza\xE7\xF5es'), React.createElement(PackageButton, {
      size: 'small',
      fluid: true,
      outline: true,
      onClick: function onClick() {
        return _this2.featured('PACKAGE_BRONZE');
      }
    }, 'Destacar')))), React.createElement(ButtonDiv, null, React.createElement(LinkCustom, {
      href: '',
      type: 'primary',
      onClick: function onClick(e) {
        e.preventDefault();
        _this2.deleteAndContinue();
      }
    }, 'N\xE3o, obrigado. Quero excluir meu an\xFAncio')));
  };
  return Bump;
}(React.Component);
Bump.propTypes = process.env.NODE_ENV !== "production" ? {
  closeModal: PropTypes.func,
  nextStep: PropTypes.func,
  handleChange: PropTypes.func,
  values: PropTypes.object
} : {};
export default Bump;